// Centralized image URLs - real Linea Bodendesign project photos
const A = "https://customer-assets.emergentagent.com/job_bodendesign-staging/artifacts";

export const IMG = {
  // HERO: anthracite terrace with white rhombus inlay (signature project)
  hero: `${A}/5zkugav4_20190403_122122.jpg`,
  heroAlt: `${A}/7qqawjej_Bild%20IHM%202020.jpg`,

  areas: {
    terrasse: `${A}/7qqawjej_Bild%20IHM%202020.jpg`,           // yellow house meander
    treppe: `${A}/bnigcquv_IMG-20230610-WA0003.jpg`,           // outdoor staircase
    balkon: `${A}/nm4e7wy8_IMG-20190620-WA0003.jpg`,           // red/burgundy balcony
    eingang: `${A}/ekzy7pu3_20130530_095755.jpg`,              // rhombus inlay entrance
    gehweg: `${A}/tytsgh3t_IMG-20190601-WA0003.jpg`,           // brick house gehweg
    innen: `${A}/lb81l1qi_20180124_132739.jpg`,                // kitchen with coffee beans
  },

  textures: [
    { name: "Grigio Carnico", url: `${A}/wjrf36mq_Grigio%20carnico.jpg` },
    { name: "Rouge Royal",    url: `${A}/2adlg6bk_IMG-20190414-WA0047.jpg` },
    { name: "Rosso Verona",   url: `${A}/35dbg3qz_IMG-20190414-WA0050.jpg` },
    { name: "Verde Alpi",     url: `${A}/13emmoy9_IMG-20190414-WA0051.jpg` },
    { name: "Botticcino",     url: `${A}/xeo83el3_IMG-20190414-WA0059.jpg` },
    { name: "Arabescato",     url: `${A}/5187wgcx_IMG-20190414-WA0064.jpg` },
    { name: "Bardiglio",      url: `${A}/n2qdpgmb_IMG-20190414-WA0069.jpg` },
    { name: "Carrara",        url: `${A}/t1qbcof3_IMG-20190414-WA0073.jpg` },
    { name: "Occhialino",     url: `${A}/63bo7vir_IMG-20190414-WA0076.jpg` },
    { name: "Nero Ebano",     url: `${A}/pl6itwp0_IMG-20190414-WA0079.jpg` },
  ],

  // Gallery on home page - curated mix of real signature projects
  gallery: [
    `${A}/5zkugav4_20190403_122122.jpg`,                 // anthracite terrace w/ rhombus
    `${A}/30jstbif_WP_000011%281%29.jpg`,                // Walt Disney star
    `${A}/lb81l1qi_20180124_132739.jpg`,                 // kitchen coffee beans
    `${A}/nm4e7wy8_IMG-20190620-WA0003.jpg`,             // red balcony
    `${A}/l9jlmrjf_20130727_181110-1.jpg`,               // green house compass star
    `${A}/ekzy7pu3_20130530_095755.jpg`,                 // rhombus entry steps
  ],

  // Showroom piece - perfect for "Warum Linea" / Workshop section
  workshop: `${A}/7crtfzyw_20210111_134236.jpg`,
  logo: `${A}/wvf6ierv_Linea%20Logo.png`,

  // PU Designboden (separate product line)
  pu: {
    hero: `${A}/m9dyaoii_20220401_130637%5B21931%5D.jpg`,         // marble PU room
    white: `${A}/8lq275gy_20200219_124436.jpg`,                  // white glossy PU
    detail: `${A}/4zim1vy1_20220401_130716%5B21925%5D.jpg`,      // marble detail close-up
  },

  // Sponsoring - Joshua Ernst, LineaMotion Racing Team
  racing: {
    portrait: `${A}/ssnqau10_IMG_5459.jpg`,                       // helmet front portrait
    action: `${A}/9jqlk56s_IMG_6018.jpg`,                         // rear view on kart
    logo: `${A}/549gbr9h_LineaMotion%20Logo.png`,                 // LineaMotion Racing Team logo
  },

  // Vorher / Nachher Paare
  beforeAfter: [
    {
      title: "Außentreppe Eingang",
      color: "Grigio Carnico",
      before: `${A}/2mg63lsg_20181112_125349.jpg`,
      after: `${A}/9z7l168m_20181116_131502.jpg`,
    },
  ],
};
